import { NgModule } from '@angular/core';
import { SchedulingCampaignsService } from './campaigns-service/campaigns.service';
import { SchedulingEventsService } from './events-service/events.service';
import { SchedulingApiService } from './scheduling-api.service';

@NgModule({
  providers: [
      SchedulingApiService,
      SchedulingEventsService,
      SchedulingCampaignsService
    ]
})
class SchedulingApiModule { }

export { SchedulingApiModule };
